// @ts-nocheck
import { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import { useAppSelector } from '../../store/hooks';
import { getAuthDetails } from '../../store/state/authSlice';
import NoProfileAvatar from '../../assets/static/mock-images/avatars/avatar_1.png';
import { useFindByParkingLocationIdDocMutation } from '../../store/api/uploadDocumentApi';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Home',
    icon: 'eva:home-fill',
    linkTo: '/',
  },
  {
    label: 'Profile',
    icon: 'eva:person-fill',
    linkTo: '#',
  },
  {
    label: 'Settings',
    icon: 'eva:settings-2-fill',
    linkTo: '#',
  },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const [open, setOpen] = useState(null);
  const [isImgUrl, setIsImgUrl] = useState(null);
  const currentUser = useAppSelector(getAuthDetails);
  const token: any = JSON.parse(localStorage.getItem('login') || '{}');
  const [getDocumentForm, getDocumentResponse] = useFindByParkingLocationIdDocMutation();
  console.log(getDocumentResponse,"getDocumentResponse")

  useEffect(() => {
    if(token.userType === "UTSP"){
      getDocumentForm({ token: token.token, serviceProviderId: token.serviceProviderId });
    } 
  }, []);

  useEffect(() => {
    if (getDocumentResponse.isSuccess) {
      getDocumentResponse.data &&
        getDocumentResponse.data.filter((item) => {
          if (item.docType === 'COMPANY_LOGO') {
            setIsImgUrl(item.filePreSignedUrl);
          }
        });
    }
  }, [getDocumentResponse.isSuccess]);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleLogout = async () => {
    setOpen(null);
  };

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar src={isImgUrl !== null ? isImgUrl : NoProfileAvatar} alt="photoURL" />
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {currentUser && currentUser.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {currentUser && currentUser.username}
          </Typography>
        </Box>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem component={RouterLink} sx={{ m: 1 }} to="/dashboard/reset-password" onClick={handleLogout}>
          Reset Paasword
        </MenuItem>
        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem component={RouterLink} sx={{ m: 1 }} to="/logout" onClick={handleLogout}>
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
